import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const alphaEldConfig: TSPConfig = {
  key: 'alphaeld',
  name: 'Alpha ELD',
  imageName: 'alpha_eld',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your Alpha ELD profile. It should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Alpha ELD Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default alphaEldConfig;
